import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { eAppContext, LoginInput, QueovalDik, GlobalParams, eLogMode, ConfigFile, eLoginStart } from '../models';
import { CoreService } from '../services';
import { HttpClient } from '@angular/common/http';
import { mergeMap, catchError } from 'rxjs/operators';
import { LoginExtranetService } from './common.login.srv.extranet';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CommonLoginService extends LoginExtranetService {

  constructor(
    protected indParam: CoreService,
    protected http: HttpClient,
    private router: Router
  ) { super(indParam, http); }


  getConfig(inputData: LoginInput): Observable<QueovalDik> {
    const mr: number = Math.random();
    //return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((data: any) => {
    let cf: ConfigFile;
    switch (inputData.Context) {
      case eAppContext.LOGINEX:
        //#region app-login for Extranet
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((data1: any) => {
          cf = { apiUrl: data1.loginApi, appUrl: data1.siteEX, loginMode: 'FULL-ANG' };
          this.indParam.AppParams = new GlobalParams(eAppContext.EXTRANET, cf.appUrl, cf.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.FULLANGULAR;
          //////////if (data1.ForceUrl && data1.ForceUrl === '1') {
          //////////  // only for testing reasons, we can force a specific redirect throug the config.json file (ForceUrl = '1', apiEX = 'our site')
          //////////  this.indParam.stockData("EX-FORCE", data1.apiEX)
          //////////}
          return this.getLogoDB(inputData.NameDB);
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      //#endregion
      case eAppContext.LOGINEL:
        //#region app-login for ELearning
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((data2: any) => {
          cf = { apiUrl: data2.loginApi, appUrl: data2.siteEL, loginMode: '' };
          this.indParam.AppParams = new GlobalParams(eAppContext.ELEARNING, cf.appUrl, cf.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.NONE;
          //////////if (data2.ForceUrl && data2.ForceUrl === '1') {
          //////////  // only for testing reasons, we can force a specific redirect throug the config.json file (ForceUrl = '1', apiEL = 'our site')
          //////////  this.indParam.stockData("EL-FORCE", data2.apiEL)
          //////////}
          return this.getLogoDB(inputData.NameDB);
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      //#endregion
      //////////case eAppContext.ELEARNING:
      //////////  //#region app-elearning
      //////////  switch (inputData.LoginStart) {
      //////////    case eLoginStart.COMPLOGIN:
      //////////    //////////// connection via app-elearning from login.component (no more available)
      //////////    ////////////return this.getLogoDB(inputData.NameDB);
      //////////    //////////return of(new QueovalDik('ERROR', `LA CONNEXION PAR LA COMPOSANTE DE LOGIN DE L'APPEL N'EST PLUS DISPONIBLE`));
      //////////    //////////case eLoginStart.PORTAIL:
      //////////    //////////  // connection via app-elearning from app-extranet
      //////////    //////////  this.indParam.AppParams = new GlobalParams(inputData.Context, inputData.AppUrl, inputData.ApiUrl);
      //////////    //////////  this.indParam.AppParams.loginMode = eLogMode.NONE;

      //////////    //////////  const us: string = inputData.getStorage('extranetuser');
      //////////    //////////  const ps: string = inputData.getStorage('extranetpswd');
      //////////    //////////  return this.portailLogin(us, ps, inputData.NameDB, eAppContext.ELEARNING);
      //////////    //////////case eLoginStart.APPLOGIN:
      //////////    //////////  // connection via app-elearning from app-login
      //////////    //////////  this.indParam.AppParams = new GlobalParams(inputData.Context, inputData.AppUrl, inputData.ApiUrl);
      //////////    //////////  this.indParam.AppParams.loginMode = eLogMode.NONE;

      //////////    //////////  const al: string = inputData.getStorage('applogin');
      //////////    //////////  return this.getSessionData(al);
      //////////    //////////default:
      //////////    //////////  return of(new QueovalDik('OK', ''));
      //////////  }
      ////////////#endregion
      case eAppContext.QUESTIONNAIRE:
        //#region app-questionnaire login.component
        // AT THE MOMENT NO PEOPLE CONNECT TO QUESTIONNAIRE APP VIA ITS LOGIN PAGE
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((data4: any) => {
          this.indParam.AppParams = new GlobalParams(inputData.Context, data4.appUrl, data4.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.NONE;

          switch (inputData.LoginStart) {
            //////////case eLoginStart.COMPLOGIN:
            //////////  return this.getLogoDB(inputData.NameDB);
            case eLoginStart.PORTAIL:
              const us: string = inputData.getStorage('extranetuser');
              const ps: string = inputData.getStorage('extranetpswd');
              return this.LoginFromPortail(us, ps, inputData.NameDB, eAppContext.QUESTIONNAIRE);
            case eLoginStart.MAIL:
              const use: string = inputData.getStorage('usermail');
              const pse: string = inputData.getStorage('pswdmail');
              return this.mailLogin(use, pse, inputData.NameDB, inputData.Context);
            //////////case eLoginStart.APPLOGIN:
            //////////  const al: string = inputData.getStorage('applogin');
            //////////  return this.getSessionData(al);
            default:
              return of(new QueovalDik('OK', ''));
          }
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      //#endregion
      //////////case eAppContext.EXTRANET:
      //////////  //#region app-extranet login.component
      //////////  switch (inputData.LoginStart) {
      //////////    //////////case eLoginStart.COMPLOGIN:
      //////////    //////////  // connection via app-elearning from login.component (no more available)
      //////////    //////////  //return this.getLogoDB(inputData.NameDB);
      //////////    //////////  return of(new QueovalDik('ERROR', `LA CONNEXION PAR LA COMPOSANTE DE LOGIN DE L'APPEL N'EST PLUS DISPONIBLE`));
      //////////    //////////case eLoginStart.MAIL:
      //////////    //////////  // connection via app-elearning from mail
      //////////    //////////  return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((data5: any) => {
      //////////    //////////    this.indParam.AppParams = new GlobalParams(inputData.Context, data5.appUrl, data5.apiUrl);
      //////////    //////////    this.indParam.AppParams.loginMode = (data5.loginMode && data5.loginMode === 'FULL-ANG') ? eLogMode.FULLANGULAR : eLogMode.MIXED;

      //////////    //////////    const us: string = inputData.getStorage('usermail');
      //////////    //////////    const ps: string = inputData.getStorage('pswdmail');
      //////////    //////////    return this.mailLogin(us, ps, inputData.NameDB, inputData.Context);
      //////////    //////////  }), catchError((error: Error) => {
      //////////    //////////    console.error(error ? JSON.stringify(error) : '');
      //////////    //////////    return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
      //////////    //////////  }));
      //////////    //////////case eLoginStart.APPLOGIN:
      //////////    //////////  // connection via app-elearning from app-login
      //////////    //////////  this.indParam.AppParams = new GlobalParams(inputData.Context, inputData.AppUrl, inputData.ApiUrl);
      //////////    //////////  this.indParam.AppParams.loginMode = eLogMode.NONE;
      //////////    //////////  const al: string = inputData.getStorage('applogin');
      //////////    //////////  return this.getSessionData(al);
      //////////    default:
      //////////      return of(new QueovalDik('OK', ''));
      //////////  }
      ////////////#endregion
      case eAppContext.QUEOVAL:
        //#region app-queoval login.component
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((data6: any) => {
          this.indParam.AppParams = new GlobalParams(inputData.Context, data6.appUrl, data6.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.NONE;

          return of(new QueovalDik('OK', ''));
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      //#endregion
      default:
        return of(new QueovalDik('OK', ''));
    }
    //}), catchError((error: Error) => {
    //  console.error(error ? JSON.stringify(error) : '');
    //  return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
    //}));
  }

  openView(routepath: string): void {
    this.router.navigate([routepath]);
  }

  private getLogoDB(db: string): Observable<QueovalDik> {
    if (db !== '') {
      return this.http.get<string>(`${this.indParam.AppParams.apiUrl}api/loginapp/getpicture/${db}`).pipe(mergeMap((result: string) => {
        if (result !== '') {
          //this.inputData.bigLogoUrl = result;
          //this.logoUrl = this.inputData.bigLogoUrl;
        }
        return of(new QueovalDik('OK', result));
      }), catchError((error: Error) => {
        console.error('Error getting logo DB: ');
        console.error(JSON.stringify(error));
        return of(new QueovalDik('ERROR', 'Erreur sur le retour du logo du client'));
      }));
    }
    return of(new QueovalDik('OK', '|'));
  }
}
